import { Injectable } from '@angular/core';
import {environment} from "@env/environment";
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {AppointmentDocument} from "@app/shared/interfaces/appointment-document.interface";
import {switchMap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {
  private readonly nextGenBaseUrl = `${environment.apiUrl}/documents`;

  constructor(
    private http: HttpClient
  ) {}

  getDocumentsByEncounter$(personId: string, encounterId: string): Observable<AppointmentDocument[]> {
    return this.http.get<AppointmentDocument[]>(`${this.nextGenBaseUrl}/encounter/${personId}/${encounterId}`)
      .pipe(
        switchMap((result) => {
          return of(result.map(doc => {
            return {
              ...doc,
              url: `pdf-view/${personId}/${doc.id}`
            };
          }))
        })
      );
  }

  getDocumentBlob$(personId: string, documentId: string): Observable<Blob> {
    return this.http.get(`${this.nextGenBaseUrl}/pdf/${personId}/${documentId}`, { responseType: 'blob' });
  }
}
